/**
 * Module to add a shipping rates calculator to cart page.
 *
 */

import {AddressForm} from '@shopify/theme-addresses';
import {formatMoney} from '@shopify/theme-currency';
import * as Sqrl from 'squirrelly';
import axios from 'redaxios';

import getUrlString from '../util/get-url-string';

const selectors = {
  submitButton: '[data-submit-shipping]',
  form: '[data-shipping-estimate-form]',
  template: '[data-response-template]',
  country: '#estimate_address_country',
  province: '#estimate_address_province',
  zip: '#estimate_address_zip',
  wrapper: '[data-response-wrapper]',
  defaultData: 'data-default-fullname',
};

const classes = {
  success: 'shipping--success',
  error: 'errors',
};

export class ShippingCalculator {
  constructor(section) {
    this.button = section.container.querySelector(selectors.submitButton);
    this.template = section.container.querySelector(selectors.template).innerHTML;
    this.ratesWrapper = section.container.querySelector(selectors.wrapper);
    this.form = section.container.querySelector(selectors.form);
    this.country = section.container.querySelector(selectors.country);
    this.province = section.container.querySelector(selectors.province);
    this.zip = section.container.querySelector(selectors.zip);
    this.init();
  }

  enableButtons() {
    this.button.removeAttribute('disabled');
    this.button.classList.remove('disabled');
  }

  disableButtons() {
    this.button.setAttribute('disabled', 'disabled');
    this.button.classList.add('disabled');
  }

  render(rates) {
    if (this.template && this.ratesWrapper) {
      const rendered = Sqrl.render(this.template, rates);
      this.ratesWrapper.innerHTML = rendered;
    }
    this.enableButtons();
    this.ratesWrapper.style.removeProperty('display');
  }

  estimate(shipping_address) {
    const encodedShippingAddressData = encodeURI(
      getUrlString({
        shipping_address: shipping_address,
      })
    );
    const url = `${window.theme.routes.cart}/shipping_rates.json?${encodedShippingAddressData}`;
    const instance = this;
    axios
      .get(url)
      .then(function (response) {
        // handle success
        const items = instance.sanitize(response);
        instance.render(items);
        instance.enableButtons();
        instance.ratesWrapper.style.removeProperty('display');
      })
      .catch(function (error) {
        // handle errors
        const errors = instance.sanitizeErrors(error);
        instance.render(errors);
      });
  }

  sanitize(response) {
    const sanitized = {};
    sanitized.class = classes.success;
    sanitized.items = [];
    if (response.data.shipping_rates && response.data.shipping_rates.length > 0) {
      const rates = response.data.shipping_rates;
      rates.forEach((r) => {
        let item = {};
        item.title = r.presentment_name;
        item.value = formatMoney(r.price, theme.moneyFormat);
        sanitized.items.push(item);
      });
    } else {
      sanitized.items[0] = {value: theme.strings.noShippingAvailable};
    }
    return sanitized;
  }

  sanitizeErrors(response) {
    const errors = {};
    errors.class = classes.error;
    errors.items = [];
    if (typeof response.data === 'object') {
      for (const [key, value] of Object.entries(response.data)) {
        let item = {};
        item.title = key.toString();
        item.value = value.toString();
        errors.items.push(item);
      }
    } else {
      errors.items[0] = {value: theme.strings.noShippingAvailable};
    }
    return errors;
  }

  init() {
    const htmlEl = document.querySelector('html');
    let locale = 'en';
    if (htmlEl.hasAttribute('lang') && htmlEl.getAttribute('lang') !== '') {
      locale = htmlEl.getAttribute('lang');
    }

    if (this.form) {
      AddressForm(this.form, locale, {
        shippingCountriesOnly: true,
      });
    }

    if (this.country && this.country.hasAttribute('data-default') && this.province && this.province.hasAttribute('data-default')) {
      this.country.addEventListener('change', function () {
        this.country.removeAttribute('data-default');
        this.province.removeAttribute('data-default');
      });
    }

    if (this.button) {
      this.button.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          this.disableButtons();
          while (this.ratesWrapper.firstChild) this.ratesWrapper.removeChild(this.ratesWrapper.firstChild);
          this.ratesWrapper.style.display = 'none';
          const shippingAddress = {};
          let elemCountryVal = this.country.value;
          let elemProvinceVal = this.province.value;
          const elemCountryData = this.country.getAttribute(selectors.defaultData);
          if (elemCountryVal === '' && elemCountryData && elemCountryData !== '') {
            elemCountryVal = elemCountryData;
          }
          const elemProvinceData = this.province.getAttribute(selectors.defaultData);
          if (elemProvinceVal === '' && elemProvinceData && elemProvinceData !== '') {
            elemProvinceVal = elemProvinceData;
          }
          shippingAddress.zip = this.zip.value || '';
          shippingAddress.country = elemCountryVal || '';
          shippingAddress.province = elemProvinceVal || '';
          this.estimate(shippingAddress);
        }.bind(this)
      );
    }
  }
}
